import { useState } from 'react';

/**
 * Custom hook for PersonalisationSlotHeader logic.
 * @returns {Object} View model for the slot header component.
 */
export function useViewModel() {
  const [helperModalOpen, setHelperModalOpen] = useState(false);

  return {
    helperModalOpen,
    setHelperModalOpen
  };
}
